// Vendor
import $ from 'jquery';

// Modules
import Helpers from '../helpers/util';
import GoogleMapsAPI from './GoogleMapsAPI';
import ChromeAutoCompleteHelper from './ChromeAutoCompleteHelper';

class AutocompleteAddress {
	constructor($el, $addressForm) {
		this.$el = $el;
		this.$document = $(document);
		this.$parent = $el.closest('.js-field');
		this.$cantFind = this.$parent.find('.js-address-cantfind');
		this.$addressForm = $addressForm;
		this.componentForm = {
			'js-address-street_number': 'short_name',
			'js-address-route': 'long_name',
			'js-address-locality': 'long_name',
			'js-address-administrative_area_level_1': 'short_name',
			'js-address-country': 'long_name',
			'js-address-postal_code': 'short_name'
		};

		this.isEmpty = true; // Geolocation input booleon
		this.hiddenFields = true;

		this.clsHidden = 'is-hidden';
		this.clsVisible = 'is-visible';
		this.clsRequired = 'js-field-required';
		this.clsDisabled = 'field-address-disabled';

		this.init();
	}

	init() {
		ChromeAutoCompleteHelper.hideAutocomplete(this.$el[0]); // SPVO-20
		GoogleMapsAPI.load().then(() => {
			this.attachEvents();
		});
	}

	// Before submitting, show the 'address' field
	prepareForSubmit() {
		ChromeAutoCompleteHelper.showAutocomplete(this.$el[0]);
	}

	attachEvents() {
		this.autocomplete = new window.google.maps.places.Autocomplete(
			this.$el.get(0),
			{ types: ['geocode'] }
		);

		// Sydney
		let geolocation = {
			lat: -33.883299,
			lng: 151.195955
		};

		let circle = new window.google.maps.Circle({
			center: geolocation,
			radius: 202484
		});

		this.autocomplete.setBounds(circle.getBounds());

		this.autocomplete.addListener('place_changed', () => {
			this.fillInAddress();
			this.isEmpty = false;
		});

		this.$cantFind.on('click', evt => {
			evt.preventDefault();

			this.hiddenFields = !this.hiddenFields;

			if (!this.hiddenFields) {
				this.showHiddenFields();
			} else {
				this.hideHiddenFields();
			}

			let response = {
				element: this.$el,
				isHidden: this.hiddenFields
			};

			Helpers.pubsub.publish('AutocompleteAddress-cantFind', response);
		});

		this.$el.on('blur', () => {
			this.isLocationEmpty();
			this.emptyInput();
		});

		const keyboard = {
			space: 8,
			esc: 27,
			enter: 13
		};

		this.$document.on('keydown', evt => {
			if (evt.keyCode === keyboard.enter) {
				//to avoid refresh page pressing enter button on autocomplete field
				if (this.isEmpty && this.$el.length > 0) {
					evt.preventDefault();
				}
			}
		});

		this.$document.on('keyup', evt => {
			if (evt.keyCode === keyboard.space) {
				this.isLocationEmpty();
			}
			if (evt.keyCode === keyboard.esc) {
				this.emptyInput();
			}
		});
	}

	isLocationEmpty() {
		if (this.$el.val() === '') {
			this.isEmpty = true;
		}
	}

	emptyInput() {
		if (this.isEmpty) {
			this.$el.val('');
		}
	}

	showHiddenFields() {
		// Show Fields
		this.$addressForm.addClass(this.clsVisible);

		// Disable location finder
		this.$el.addClass(this.clsDisabled);
		this.$el.attr('disabled', true);
		this.$el.attr('placeholder', '');
		this.$el.val('');

		// Location finder is no longer required
		this.$el.removeClass(this.clsRequired);
	}

	hideHiddenFields() {
		// Hide Fields
		this.$addressForm.removeClass(this.clsVisible);

		// Enable location finder
		this.$el.removeClass(this.clsDisabled);
		this.$el.attr('disabled', false);
		this.$el.attr('placeholder', 'Sydney CBD, NSW 2000, Australia');

		// Location finder is required
		this.$el.addClass(this.clsRequired);

		// Clear fields
		$.each(this.componentForm, i => {
			$('.' + i).val('');
		});
	}

	fillInAddress() {
		let place = this.autocomplete.getPlace();

		$.each(this.componentForm, i => {
			$('.' + i).val('');
		});

		for (let i = 0; i < place.address_components.length; i++) {
			let addressType = place.address_components[i].types[0];
			if (this.componentForm['js-address-' + addressType]) {
				let val =
					place.address_components[i][
						this.componentForm['js-address-' + addressType]
					];
				let $target = $('.js-address-' + addressType);
				$target.val(val);
			}
		}
	}
}

export default AutocompleteAddress;
